
<div *ngIf="longlat === null">
    <label> {{'Msg_startPoint' | translate}} </label>
</div>

<div *ngIf="longlat !== null" >
    <div id="map"></div>
</div>
